import React from 'react';

import SignupLegalScreen from './SignupLegalScreen';

export default (props: any) => <SignupLegalScreen {...props} type="tos" progressStatus={100 / 10 * 9} />;
